import { DateTime } from 'luxon';
import { removeUnderscore } from "../../../Common/utils/universalFuntions";

export const transactionReportDynamicFields = (dataArray, type) => {
    if (type === 'DOCUMENTS') {
        const resureTRDocuments = document.getElementById('resureTRDocuments');
        if (resureTRDocuments) {
            resureTRDocuments.innerHTML = dataArray?.map((doc) => {
                const buyerDocStatus = doc.buyerSignStatus === "SUBMITTED" && doc.buyerAgentSignStatus === "SUBMITTED" ? "SUBMITTED" : "DRAFT";
                const sellerDocStatus = doc.sellerSignStatus === "SUBMITTED" && doc.sellerAgentSignStatus === "SUBMITTED" ? "SUBMITTED" : "DRAFT";
                if (doc.contractType === "TR") return null;
                return `
                    <tr>
                        <td>${doc.RTDInitiator || ''}</td>
                        <td>${doc.contractsData?.name || ''}</td>
                        <td>${buyerDocStatus}</td>
                        <td>${sellerDocStatus}</td>
                    </tr>
                `
            }).join('');
        }
    } else if (type === 'SIGNATURE_DETAILS') {
        const signatureDetailsTR = document.getElementById('signatureDetailsTR');
        if (signatureDetailsTR) {
            const submittedDocsHTML = dataArray
                // ?.filter(ele => ele?.buyerSignStatus === 'SUBMITTED' || ele?.buyerAgentSignStatus === 'SUBMITTED' || ele?.sellerSignStatus === 'SUBMITTED' || ele?.sellerAgentSignStatus === 'SUBMITTED')
                ?.map(row => {
                    return row?.signatureInfo?.map(signer => `
                        <tr>
                            <td>${removeUnderscore(row?.contractType || row?.contractsData?.contractType) || ''}</td>
                            <td>
                                <div style="font-weight: bold">${signer?.fullName || ''}</div>
                                <div style="color: rgb(113, 111, 111); font-size: small;">${signer?.email || ''}</div>
                                <div style="color: rgb(113, 111, 111); font-size: small;">${signer?.key || ''}</div>
                            </td>
                            <td>${removeUnderscore(signer?.roleType) || ''}</td>
                            <td>
                           <div>${signer?.ip?.region}/${signer?.ip?.country || ''}</div>
                                <div style="color: rgb(113, 111, 111); font-size: small;">(${signer?.ip?.latitude || ''},${signer?.ip?.longitude || ''})</div>
                            </td>
                            <td>
                                <div>${signer?.timeStamp ? (DateTime.fromMillis(signer.timeStamp).toFormat("MMMM d, yyyy hh:mm a")) : '-'}</div>
                                <div style="color: rgb(113, 111, 111); font-size: small;">${signer?.ip?.timezone?.name || ''}</div>
                            </td>
                            <td>${signer?.ip?.security?.is_vpn ? "Yes" : "No"}</td>
                        </tr>
                    `).join('');
                }).join('');
            signatureDetailsTR.innerHTML = submittedDocsHTML;
        }
    } else if (type === 'EMAIL_COMMUNICATIONS') {
        const emailCommunicationsSection_tbody = document.getElementById('emailCommunicationsSection_tbody');
        if (emailCommunicationsSection_tbody && dataArray && Array.isArray(dataArray)) {
            emailCommunicationsSection_tbody.innerHTML = dataArray?.map((record) => {
                let dt = "", fwdDate = "";
                if (record?.forwardedDate) {
                    dt = typeof record.forwardedDate === 'string'
                        ? DateTime.fromISO(record.forwardedDate)
                        : (typeof record.forwardedDate === 'number'
                            ? DateTime.fromMillis(record.forwardedDate)
                            : null);

                    fwdDate = dt?.toFormat("MMMM d, yyyy hh:mm a");
                }

                return `
                    <tr>
                        <td class="clickable" data-TR-expand-table>
                            <div style="display: flex;">
                                <span class="dropdown-icon"><i
                                        class="bi bi-caret-right-fill"></i></span>
                                <span style="width: 100%; font-weight: bold;">${record?.from}</span>
                            </div>
                            <div class="list-container">
                                <ul>
                                    ${record?.originalTo?.map((email)=> {return `<li class="dropDownContent">${email}</li>`}).join("")}
                                    ${record?.originalCc?.map((email)=> {return `<li class="dropDownContent">${email}</li>`}).join("")}
                                    ${record?.forwardedTo?.map((email)=> {return `<li class="dropDownContent">${email}</li>`}).join("")}
                                </ul>
                            </div>
                        </td>
                        <td class="subjectColumn clickable" data-TR-expand-table>${record?.subject}</td>
                        <td>${record?.forwardedDate ? fwdDate : '-'}</td>
                        <td><div class="clickable" style="text-decoration: underline; color: -webkit-link;" data-open-email=${JSON.stringify({s3Bucket: record.s3Bucket, s3Key: record.s3Key, logId: record._id, originalCc: record?.originalCc, forwardedTo: record?.forwardedTo })}>View</div></td>
                    </tr>
                `
            }).join('');
        }
    } else if (type === 'SHARED_DOCS') {
        const sharedDocumentSection_tbody = document.getElementById('sharedDocumentSection_tbody');
        if (sharedDocumentSection_tbody && dataArray) {
            sharedDocumentSection_tbody.innerHTML = dataArray?.map((record) => {
                let dt = "", sendDate = "";
                if (record?.sentDateMili) {
                    dt = typeof record.sentDateMili === 'string'
                        ? DateTime.fromISO(record.sentDateMili)
                        : (typeof record.sentDateMili === 'number'
                            ? DateTime.fromMillis(record.sentDateMili)
                            : null);
                    sendDate = dt?.toFormat("MMMM d, yyyy hh:mm a");
                }
                return `
                    <tr>
                        <td>WEB</td>
                        <td>
                            <span style="display: flex; justify-content: left; align-items: center; gap: 5px;">
                                ${
                                    record?.fileType === 'IMAGE' ? '<i class="bi bi-file-earmark-image" style="color: #711ae1;"></i>' : 
                                    record?.fileType === 'PDF' ? '<i class="bi bi-file-earmark-pdf" style="color: red;"></i>' :
                                    '<i class="bi bi-file-earmark-text" style="color: #74b3ed;"></i>'
                                }
                                ${record?.fileName}
                            </span>
                        </td>
                        <td>${record?.fileType}</td>
                        <td>${record?.sentDateMili ? sendDate : '-'}</td>
                        <td>${record?.sharedBy?.fullName}</td>
                        <td><a href="${record?.fileUrl}" target="_blank">Open File Link</a></td>
                    </tr>
                `
            }).join('');
        }
    // } else if (type === 'EMAIL_LOGS') {
    //     const emailLogs_tbody = document.getElementById('emailLogs_tbody');
    //     if (emailLogs_tbody && dataArray?.length > 0) {
    //         // Group by `from` email
    //         const uniqueEmailsMap = new Map();
    //         dataArray.forEach(record => {
    //             if (!uniqueEmailsMap.has(record.from)) {
    //                 uniqueEmailsMap.set(record.from, record);
    //             }
    //         });
    //         const uniqueEmailRecords = Array.from(uniqueEmailsMap.values());
    //         emailLogs_tbody.innerHTML = uniqueEmailRecords.map(record => 
    //             `
    //                 <tr>
    //                     <td>${record?.from}</td>
    //                     <td>
    //                         <div class="clickable" style="text-decoration: underline; color: -webkit-link;" 
    //                             data-open-email='${JSON.stringify({ source: 'EMAIL_LOGS', from: record.from})}'>
    //                             View
    //                         </div>
    //                     </td>
    //                 </tr>
    //             `).join("")
    //     }
    } else if (type === 'EMAIL_LOGS') {
        const emailLogs_tbody = document.getElementById('emailLogs_tbody');
        if (emailLogs_tbody && dataArray?.length > 0) {
            emailLogs_tbody.innerHTML = dataArray.map(record => 
                `
                    <tr>
                        <td>${record?.from}</td>
                        <td>${record?.originalTo}</td>
                        <td>${record?.subject}</td>
                        <td>${record?.sentDate ? (DateTime.fromISO(record.sentDate).toFormat("MMMM d, yyyy hh:mm a")) : '-'}</td>
                        <td>
                            <div class="clickable" style="text-decoration: underline; color: -webkit-link;" 
                                data-open-email='${JSON.stringify({ source: 'EMAIL_LOGS', logId: record?._id})}'>
                                View
                            </div>
                        </td>
                    </tr>
                `).join("")
        }
    }
}
